import React from 'react';
import { withStyles } from 'material-ui/styles';
import {
  ListItem,
  ListItemText,
} from 'material-ui/List';
import SearchResultsItemCard from './search_results_item_card.js';
import SearchResultsItemDiv from './search_results_item_div.js';

const styles = theme =>({

});

class SearchResultsItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleListItemClick(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  componentDidMount() {
  }

  render() {
    if(this.props.type === 'card'){
      return this.renderCard();
    } else if (this.props.type === 'list'){
      return this.renderList();
    } else {
      return this.renderDiv();
    }
  }

  renderList(){
    return (
      <ListItem button>
        <ListItemText primary={this.props.item.title} secondary={this.props.item.snippet} onClick={() => this.handleListItemClick(this.props.item.link)}/>
      </ListItem>
    );
  }

  renderCard(){
    return (
      <SearchResultsItemCard item={this.props.item}/>
    );
  }

  renderDiv(){
    return (
      <SearchResultsItemDiv item={this.props.item} uiOptions={this.props.uiOptions} devMode={this.props.devMode} server={this.props.server}/>
    );
  }

}

export default withStyles(styles)(SearchResultsItem);


// WEBPACK FOOTER //
// ./src/search/search_results_item.js